import { render, staticRenderFns } from "./DisplayQualificationElement.vue?vue&type=template&id=f16d6a6a&scoped=true&"
import script from "./DisplayQualificationElement.vue?vue&type=script&lang=ts&"
export * from "./DisplayQualificationElement.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayQualificationElement.vue?vue&type=style&index=0&id=f16d6a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16d6a6a",
  null
  
)

/* custom blocks */
import block0 from "./DisplayQualificationElement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
